import UserHome from './../views/user/UserHome.vue'
import Profil from './../views/user/Profil.vue'

const user = [
  {
    path: '/user/verifikasi',
    component: UserHome,
    meta: { auth: true }    
  },
  {
    path: '/user/profil',
    component: Profil,
    meta: { auth: true }    
  },
]

export default user